import Barcode from "react-barcode";
import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { ADD_ACTIVITY, getApiBaseUrl } from "../../Config/Config";
import { Spin } from "antd";

const AssetitemBarcode = ({ barcodeValue }) => {
  const barcodeWrapperRef = useRef(null);
  const [barcodeHTML, setBarcodeHTML] = useState("");
  const [printers, setPrinters] = useState([]);
  const [selectedPrinterId, setSelectedPrinterId] = useState("");
  const barcodeNUM = barcodeValue?.Barcode;
  const filterLabel = barcodeValue?.Lable;

  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const svgElement = barcodeWrapperRef.current?.querySelector("svg");
    if (svgElement) {
      setBarcodeHTML(svgElement.outerHTML);
    }
  }, [barcodeValue]);
  useEffect(() => {
    const fetchPrinters = async () => {
      try {
        const response = await fetch(
          `${getApiBaseUrl()}/api/getprinterIpAdress`
        );
        const data = await response.json();
        if (Array.isArray(data?.ResultData)) {
          setPrinters(data.ResultData);
        }
      } catch (error) {
        console.error("Error fetching printers:", error);
      }
    };

    fetchPrinters();
  }, []);

  const logActivity = async (isSuccess, notes) => {
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    const userId = user?.UserID || 0;

    try {
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: userId,
          PerformedOn: new Date().toISOString(),
          Notes: notes,
          Location: "AssetitemBarcode_Print",
          IsSucces: isSuccess ? 1 : 0,
        }),
      });
    } catch (err) {
      console.error("Failed to log print activity:", err);
    }
  };

  const handlePrint = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!selectedPrinterId) {
      alert("Please select a printer.");
      return;
    }

    const printer = printers.find((p) => p.ipadress == selectedPrinterId);
    if (!printer) {
      alert("Selected printer not found.");
      return;
    }

    const barcode = barcodeValue?.Barcode;
    const label = filterLabel;
    const ip = printer.ipadress;

    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    const userId = user?.UserID || 0;

    const url = `${getApiBaseUrl()}/api/printLabel?ip=${encodeURIComponent(
      ip
    )}&barcode_number=${encodeURIComponent(
      barcode
    )}&label_text=${encodeURIComponent(label)}&Remarks=${encodeURIComponent(
      remarks
    )}&CreatedBy=${userId}`;

    try {
      const response = await fetch(url);
      const result = await response.json();

      if (response.ok && result.success) {
        Swal.fire(
          "Success",
          result.message || "Barcode sent to printer!",
          "success"
        );
        await logActivity(
          1,
          `Printed barcode ${filterLabel} to printer ${printer.name}`
        );
      } else {
        Swal.fire("Error", "Failed to print barcode", "error");
        await logActivity(
          0,
          `Failed to print barcode ${filterLabel} to printer ${printer.name}`
        );
      }
    } catch (error) {
      console.error("Print API error:", error);
      Swal.fire("Error", "Failed to connect to print service", "error");
      await logActivity(0, `Print error for barcode ${label}`);
    } finally {
      setLoading(false);
    }
  };

  const handlePrintWired = (e) => {
    e.preventDefault();

    if (!barcodeHTML) {
      alert("Barcode not ready yet!");
      return;
    }

    const printWindow = window.open("", "_blank");
    const htmlContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Barcode Print</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 0;
        }

        #print-section {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          width: 100%;
        }

        .sticker {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          padding: 10mm;
          box-sizing: border-box;
        }

        .sticker h1 {
          font-size: 20px;
          margin: 0 0 10px 0;
        }

        .barcode {
          transform: scale(1);
          transform-origin: top center;
          margin-bottom: 5mm;
        }

        @media print {
          body * {
            visibility: hidden;
          }

          #print-section,
          #print-section * {
            visibility: visible;
          }

          html,
          body {
            margin: 0;
            padding: 0;
          }

          #print-section {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        }
      </style>
    </head>
    <body>
      <div id="print-section">
        <div class="sticker">
          <h1>${filterLabel}</h1>
          <div id="barcode1" class="barcode">${barcodeHTML}</div>
        </div>
      </div>

      <script>
        window.onload = function () {
          window.print();
          window.onafterprint = function () {
            window.close();
          };
        };
      </script>
    </body>
  </html>
    `;

    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  return (
    <>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <style>
        {`
          @media (max-width: 576px) {
            #AssetitemBarcode {
              width: 90% !important;
            }
          }

          @media (min-width: 577px) and (max-width: 992px) {
            #AssetitemBarcode {
              width: 55% !important;
            }
          }

          @media (min-width: 993px) and (max-width: 1440px) {
            #AssetitemBarcode {
              width: 30% !important;
            }
          }

          @media (min-width: 1441px)  {
            #AssetitemBarcode {
              width: 22% !important;
            }
          }

          @media print {
            body * {
              visibility: hidden;
            }
            #AssetitemBarcode, #AssetitemBarcode * {
              visibility: visible;
            }
            #AssetitemBarcode {
              position: absolute;
              left: 0;
              top: 0;
            }
            #AssetitemBarcode .offcanvas-header, #AssetitemBarcode .btn-close {
              display: none; /* Hide the offcanvas header and close button */
            }
            #AssetitemBarcode .offcanvas-body {
              display: block; /* Ensure only the body section is shown */
            }
            #AssetitemBarcode .fw-bold {
              font-weight: bold;
            }
          }
        `}
      </style>

      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="AssetitemBarcode"
        aria-labelledby="offcanvasBarcodeLabel"
      >
        <form onSubmit={handlePrint}>
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasBarcodeLabel">
              Barcode Preview
            </h5>
            <div className="d-flex align-items-center ms-auto">
              <button
                className="btn btn-md btn-transparent"
                title="Print Barcode wireless"
                type="submit"
              >
                <i className="fa text-primary fs-4 fa-print"></i>
              </button>
              <button
                className="btn btn-md btn-transparent"
                title="Print Barcode wired"
                onClick={handlePrintWired}
              >
                <i className="fa-solid fa-plug fs-4 text-primary"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>

          <div className="offcanvas-body d-flex flex-column align-items-center justify-content-start">
            <div className="mb-3 w-100">
              <label className="form-label fw-bold">Select Printer</label>
              <select
                className="form-select"
                required
                value={selectedPrinterId}
                onChange={(e) => setSelectedPrinterId(e.target.value)}
              >
                <option value="">-- Select Printer --</option>
                {printers.map((printer) => (
                  <option key={printer.id} value={printer.ipadress}>
                    {printer.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">Remarks</label>
              <textarea
                rows="2"
                name="remarks"
                required
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                placeholder="Enter Remarks"
                className="form-control"
              ></textarea>
            </div>

            {barcodeNUM ? (
              <>
                <div className="w-100 d-flex justify-content-between align-items-center mb-2">
                  <p className="fw-bold mb-0"></p>
                </div>

                {/* Centered label above barcode */}
                <div className="text-center mt-4">
                  <p className="fw-bold mb-1">
                    <b> {filterLabel}</b>
                  </p>
                  {/* <Barcode value={barcodeNUM} /> */}

                  <div ref={barcodeWrapperRef}>
                    <Barcode value={barcodeNUM} renderer="svg" />
                  </div>
                </div>
              </>
            ) : (
              <p>No barcode data</p>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

AssetitemBarcode.propTypes = {
  barcodeValue: PropTypes.string,
};

export default AssetitemBarcode;
